import React from "react";
import { ACCENT, INK_SECONDARY, onActivateKey } from "./layerStyle";

/**
 * A text-link action (恢復, 恢復預設). A <span role="button"> rather than a
 * <button>: the app's global button CSS (css/button.css and the theme files)
 * skews, uppercases and pads every <button>, which a link must not get.
 */
const TextAction = ({ children, onClick, disabled = false }) => (
  <span
    role="button"
    tabIndex={disabled ? -1 : 0}
    aria-disabled={disabled}
    onClick={disabled ? undefined : onClick}
    onKeyDown={disabled ? undefined : onActivateKey(onClick)}
    style={{
      color: disabled ? INK_SECONDARY : ACCENT,
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? "default" : "pointer",
      userSelect: "none",
    }}
  >
    {children}
  </span>
);

export default TextAction;
